import React from 'react';
import DashboardLayout from '../DashboardLayout';

const StockLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default StockLayout;
